import { createFileRoute } from "@tanstack/react-router";
import { EmployeeLessonsView } from "@/components/employee/EmployeeLessonsView";

export const Route = createFileRoute("/_authenticated/employee/lessons")({
  head: () => ({ meta: [{ title: "My Lessons — Staff" }] }),
  component: EmployeeLessonsPage,
});

function EmployeeLessonsPage() {
  return <EmployeeLessonsView />;
}
